import { Injectable, inject } from '@angular/core';
import { CaseTypeState } from '../../states/case-type.state';
import { GetCaseTypesStateResult } from './get-case-types-state.result';

@Injectable({ providedIn: 'root' })
export class GetCaseTypesStateUseCase {
  private readonly _caseTypeState = inject(CaseTypeState);

  public execute(): GetCaseTypesStateResult {
    return {
      caseTypes: this._caseTypeState.caseTypes,
      activeCaseTypes: this._caseTypeState.activeCaseTypes,
      loading: this._caseTypeState.loading,
      error: this._caseTypeState.error,
      saving: this._caseTypeState.saving,
      caseTypesCount: this._caseTypeState.caseTypesCount,
      hasCaseTypes: this._caseTypeState.hasCaseTypes,
      categories: this._caseTypeState.categories,
      currentCaseType: this._caseTypeState.currentCaseType,
      loadingCategories: this._caseTypeState.loadingCategories,
      errorCategories: this._caseTypeState.errorCategories,
      loadingChecklist: this._caseTypeState.loadingChecklist,
      errorChecklist: this._caseTypeState.errorChecklist,
      savingChecklist: this._caseTypeState.savingChecklist,
      savingCaseTypeStatus: this._caseTypeState.savingCaseTypeStatus,
      isDeletingCaseType: this._caseTypeState.isDeletingCaseType,
      loadingStatuses: this._caseTypeState.loadingStatuses,
      savingStatus: this._caseTypeState.savingStatus,
      errorStatuses: this._caseTypeState.errorStatuses,
      caseTypeDeletionImpact: this._caseTypeState.caseTypeDeletionImpact,
      loadingCaseTypeDeletionImpact: this._caseTypeState.loadingCaseTypeDeletionImpact,
      errorCaseTypeDeletionImpact: this._caseTypeState.errorCaseTypeDeletionImpact,
    };
  }
}
